import DirectMobileWeb from './DirectMobileWeb'

export default DirectMobileWeb
